import { call, put, takeLatest } from 'redux-saga/effects';
import { GET_TRANSACTION_DETAILS_REQUEST, getTransactionDetailsSuccess, getTransactionDetailsFailure, getViewLocationDetailsRequest, getViewLocationDetailsSuccess, getViewLocationDetailsFailure } from '../actions/transactionActions';
import { getTransactionDetails } from '../../api/ordersPageAPI';
import { retriveViewLocationInfo } from '../../api/Admin/adminflowAPI';

export function* getTransactionDetailsSaga(action) {
	try {
		const response = yield call(getTransactionDetails, action);
		yield put(getTransactionDetailsSuccess(action.payload.transactionId, response?.data));
	} catch (e) {
		yield put(getTransactionDetailsFailure(action.payload.transactionId, e.toString()));
	}
}

function* getViewLocationDetailsSaga(action) {
	try {
		const response = yield call(retriveViewLocationInfo, action);
		yield put(getViewLocationDetailsSuccess(response));
	} catch (e) {
		yield put(getViewLocationDetailsFailure((e.toString())));
	}
}

export default function* transactionSaga() {
  yield takeLatest(GET_TRANSACTION_DETAILS_REQUEST, getTransactionDetailsSaga);
  yield takeLatest(getViewLocationDetailsRequest, getViewLocationDetailsSaga);
}
